/*
 * @description: 
 * @author: Jason Wong
 * @since: 2024-07-11 10:32:23
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/directives";

//use configurations
import "./configs";

require("expose-loader?$!jquery");
Vue.config.productionTip = false;

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
ElementUI.Table.props.tooltipEffect = {
  type: String,
  default: "light",
};
ElementUI.Tooltip.props.openDelay.default = 500;
Vue.use(ElementUI);

import easyScroll from "easyscroll";
Vue.use(easyScroll);

import plugins from "./plugins";
plugins.use();

import dyrsTag from "@/components/dyrsTag";
import pageView from "@/components/dyrsPage";
import dyrsButton from "@/components/dyrsButton";
import fontIcon from "@/components/fontIcon";
import iconButton from "@/components/iconButton";
import textFont from "./components/textIcon";
import CountInput from "./components/inputWithCounter";
import SideBarTransition from "./components/sideBarTransition.vue";
import LanguageSelector from "./components/languageSelector.vue";
import SortButton from "./components/sortButton.vue";
import InputNumber from "./components/inputNumber.vue";
import TextEditor from "./components/textEditor.vue";
import DialogEx from "./components/dialogEx.vue";

//implement font awesome
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import {
  faDownload,
  faArrowDown,
  faArrowUp,
  faSyncAlt,
  faCheckCircle,
  faQuestionCircle,
  faCog,
  faKey,
  faUserFriends,
  faPencilAlt,
  faPlusCircle,
  faTrashAlt,
  faMinusCircle,
  faEdit,
  faPlay,
  faCheck,
  faUser,
  faFile,
  faTimes,
  faEye,
  faList,
  faTasks,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faExclamationCircle,
  faChalkboardTeacher,
  faHeadphones,
  faHeadphonesAlt,
  faCircle,
  faPlus,
  faBook,
  faFilePowerpoint,
  faEyeSlash,
  faClock,
  faThLarge,
  faTh,
  faLock,
  faLockOpen,
  faFileAlt,
  faBroom,
  faShareAlt,
  faShareSquare,
  faChartLine,
  faStop,
  faProjectDiagram,
  faClipboardList,
  faMinus,
  faSignInAlt,
  faDatabase,
  faTv,
  faAngleLeft,
  faAngleRight,
  faCommentAlt,
  faExclamationTriangle,
  faSave,
  faArrowRight,
  faDumbbell,
  faLongArrowAltUp,
  faLongArrowAltDown,
  faLongArrowAltRight,
  faCaretUp,
  faCaretDown,
  faPenSquare,
  faThumbsUp,
  faSearch,
  faSearchPlus,
  faHome,
  faGraduationCap,
  faCalendar,
  faRetweet,
  faInfoCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faEraser,
  faMousePointer,
  faSquare,
  faShieldAlt,
  faThumbtack,
  faRedo,
  faUndo,
  faEllipsisH,
  faFileContract,
  faSpinner,
  faAngleUp,
  faAngleDown,
  faWarehouse,
  faUpload,
  faExchangeAlt,
  faUsers,
  faFont,
  faQuestion,
  faExpandArrowsAlt,
  faExpandAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faTimesCircle as farTimesCircle,
  faCircle as farCircle,
  faClone as farClone,
  faPlusSquare as farPlusSquare,
  faSquare as farSquare,
  faSave as farSave,
  faComments,
  faFile as farFile,
  faFileAlt as farFileAlt,
  faTrashAlt as farTrashAlt,
  faObjectGroup as farObjectGroup,
  faObjectUngroup as farObjectUngroup,
  faWindowMaximize as farWindowMaximize,
  faWindowRestore as farWindowRestore,
  faPaperPlane as farPaperPlane
} from "@fortawesome/fontawesome-free-regular";
import { FontAwesomeIcon, FontAwesomeLayers } from "@fortawesome/vue-fontawesome";
library.add(
  faDownload,
  faArrowDown,
  faArrowUp,
  faSyncAlt,
  faCheckCircle,
  faQuestion,
  faQuestionCircle,
  faCog,
  farClone,
  faKey,
  faUserFriends,
  faPencilAlt,
  faPlusCircle,
  faTrashAlt,
  farTrashAlt,
  faMinusCircle,
  faEdit,
  faPlay,
  faCheck,
  faUser,
  faFile,
  farFile,
  farFileAlt,
  faTimes,
  farTimesCircle,
  faEye,
  faList,
  faTasks,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faExclamationCircle,
  faChalkboardTeacher,
  faHeadphones,
  faHeadphonesAlt,
  faCircle,
  farCircle,
  farPlusSquare,
  faPlus,
  faBook,
  faEyeSlash,
  faFilePowerpoint,
  faClock,
  faThLarge,
  faTh,
  faSquare,
  faLock,
  faLockOpen,
  faFileAlt,
  faBroom,
  faShareAlt,
  faShareSquare,
  faChartLine,
  faStop,
  faProjectDiagram,
  faClipboardList,
  farSave,
  faMinus,
  faSignInAlt,
  faDatabase,
  faTv,
  faAngleLeft,
  faAngleRight,
  faComments,
  faCommentAlt,
  faExclamationTriangle,
  faSave,
  faArrowRight,
  faDumbbell,
  faLongArrowAltDown,
  faLongArrowAltUp,
  faLongArrowAltRight,
  farObjectGroup,
  farObjectUngroup,
  faCaretUp,
  faCaretDown,
  faThumbsUp,
  faPenSquare,
  faPencilAlt,
  faSearch,
  faSearchPlus,
  faHome,
  faGraduationCap,
  faCalendar,
  faRetweet,
  faInfoCircle,
  faChevronCircleLeft,
  faChevronCircleRight,
  faEraser,
  faMousePointer,
  faPencilAlt,
  faCircle,
  faSquare,
  farSquare,
  faShieldAlt,
  faThumbtack,
  faRedo,
  faUndo,
  faEllipsisH,
  faFileContract,
  faSpinner,
  faAngleUp,
  faAngleDown,
  faWarehouse,
  faUpload,
  faExchangeAlt,
  faUsers,
  faFont,
  faExpandArrowsAlt,
  faExpandAlt,
  farWindowMaximize,
  farWindowRestore,
  farPaperPlane,
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("fa-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

Vue.component("font-icon", fontIcon);
Vue.component("dyrs-button", dyrsButton);
Vue.component("dyrs-tag", dyrsTag);
Vue.component("ve-page", pageView);
Vue.component("ve-icon-button", iconButton);
Vue.component("ve-text-font", textFont);
Vue.component("ve-input", CountInput);
Vue.component("ve-sidebar-transition", SideBarTransition);
Vue.component("ve-language-selector", LanguageSelector);
Vue.component("ve-sort-button", SortButton);
Vue.component("ve-input-number", InputNumber);
Vue.component("ve-text-editor", TextEditor);
Vue.component("ve-dialog", DialogEx);

/**
 * import custome svgs
 */
import "./assets/icons";

import VCharts from "v-charts";
Vue.use(VCharts);

import "@/views/home/widgets";

import { addRouterHook } from "./utils/PageExtensions";
addRouterHook(router);

import { ignoreEnterInForm, preventDocumentDefaultDrag } from "./utils/domHelper";
preventDocumentDefaultDrag();
ignoreEnterInForm();

//init system message connector
import { systemMessageConnector } from "./views/common/data";
systemMessageConnector.attachMessageConnector();

//use i18n
import i18n from "./i18n";
window.process = process;
console.log('process',process.mode,process,process.env);

//init cache
import './utils/cache/persistent';

import "@/components/downloadMessage.js";


new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
